(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/DataWrapper', '../model/RecmdLabel', '../model/Nothing', '../model/APiDocAdminPriorityIndexUpdate', '../model/ApiDocDataWrapperString', '../model/APiDocAdminLabelUpdate'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/DataWrapper'), require('../model/RecmdLabel'), require('../model/Nothing'), require('../model/APiDocAdminPriorityIndexUpdate'), require('../model/ApiDocDataWrapperString'), require('../model/APiDocAdminLabelUpdate'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.AdminadminportalApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.DataWrapper, root.SmartCsV2Sdk.RecmdLabel, root.SmartCsV2Sdk.Nothing, root.SmartCsV2Sdk.APiDocAdminPriorityIndexUpdate, root.SmartCsV2Sdk.ApiDocDataWrapperString, root.SmartCsV2Sdk.APiDocAdminLabelUpdate);
  }
}(this, function(ApiClient, DataWrapper, RecmdLabel, Nothing, APiDocAdminPriorityIndexUpdate, ApiDocDataWrapperString, APiDocAdminLabelUpdate) {
  'use strict';

  /**
   * Adminadminportal service.
   * @module api/AdminadminportalApi
   * @version 2.0.624
   */

  /**
   * Constructs a new AdminadminportalApi. 
   * @alias module:api/AdminadminportalApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the createLabels operation.
     * @callback module:api/AdminadminportalApi~createLabelsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/RecmdLabel>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add Labels
     * @param {module:model/DataWrapper} request &lt;font&gt;Up to to 10 labels with max 50 characters each&lt;/font&gt;
     * @param {module:api/AdminadminportalApi~createLabelsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {Array.<module:model/RecmdLabel>}
     */
    this.createLabels = function(request, callback) {
      var postBody = request;

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling createLabels";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = [RecmdLabel];

      return this.apiClient.callApi(
        '/admin/admin_portal/labels', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteLabels operation.
     * @callback module:api/AdminadminportalApi~deleteLabelsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete labels by Ids.
     * Specific Client Team Auth Scope required.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.labelIds &lt;font&gt;Ids of the labels&lt;/font&gt;
     * @param {module:api/AdminadminportalApi~deleteLabelsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deleteLabels = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'labelIds': this.apiClient.buildCollectionParam(opts['labelIds'], 'csv')
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/admin/admin_portal/labels', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the postPriorityIndex operation.
     * @callback module:api/AdminadminportalApi~postPriorityIndexCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApiDocDataWrapperString} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set or remove Priority Index for Public Contents
     * @param {module:model/APiDocAdminPriorityIndexUpdate} request List of Priority-setting requests. Data type: integer; Allowed update: SET, UNSET
     * @param {module:api/AdminadminportalApi~postPriorityIndexCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ApiDocDataWrapperString}
     */
    this.postPriorityIndex = function(request, callback) {
      var postBody = request;

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling postPriorityIndex";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = ApiDocDataWrapperString;

      return this.apiClient.callApi(
        '/admin/admin_portal/priority_index', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the putContentLabel operation.
     * @callback module:api/AdminadminportalApi~putContentLabelCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApiDocDataWrapperString} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update Contents&#39; Labels
     * @param {module:model/APiDocAdminLabelUpdate} request List of requests
     * @param {module:api/AdminadminportalApi~putContentLabelCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ApiDocDataWrapperString}
     */
    this.putContentLabel = function(request, callback) {
      var postBody = request;

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling putContentLabel";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = ApiDocDataWrapperString;

      return this.apiClient.callApi(
        '/admin/admin_portal/content_labels', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the putLabel operation.
     * @callback module:api/AdminadminportalApi~putLabelCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a label by its ID.
     * Specific Client Team Auth Scope required.
     * @param {String} labelId 
     * @param {module:model/DataWrapper} request &lt;font&gt;New label value with max 50 characters&lt;/font&gt;
     * @param {module:api/AdminadminportalApi~putLabelCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.putLabel = function(labelId, request, callback) {
      var postBody = request;

      // verify the required parameter 'labelId' is set
      if (labelId == undefined || labelId == null) {
        throw "Missing the required parameter 'labelId' when calling putLabel";
      }

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling putLabel";
      }


      var pathParams = {
        'labelId': labelId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/admin/admin_portal/labels/{labelId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
